import { getMediaName, type SupportedLanguage } from '~/lib/i18n';
import { ToggleGroup, ToggleGroupItem } from '../ui/toggle-group';
import { getMediaIcon } from './media/getMediaIcon';
import type { MediaType } from './media/types';

interface Props {
  media: { type: MediaType; url: string }[];
  lang: SupportedLanguage;
  selectedMediaType: MediaType | undefined;
  setSelectedMediaType: (media: MediaType) => void;
}

export default function ArtworkControls({
  media,
  lang,
  selectedMediaType,
  setSelectedMediaType,
}: Props) {
  if (!media.length) return null;
  return (
    <ToggleGroup
      type="single"
      value={selectedMediaType}
      onValueChange={value => {
        if (value) setSelectedMediaType(value as MediaType);
      }}
    >
      {media.map(value => (
        <ToggleGroupItem key={value.type} value={value.type} className="mr-2">
          {getMediaIcon(value.type, value.type === selectedMediaType ? '#000' : '#FFF')}
          {getMediaName(value.type, lang)}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
}
